import SyosEvents from './utils/SyosEvents';
import SyosUiContainer from './SyosUiContainer';
import SyosPageComponent from './SyosPageComponent';

const Class = {
  MESSAGE: 'tn-syos-busy-indicator__message',
  SPINNING: 'tn-syos-busy-indicator--spinning',
  RESERVING: 'tn-syos-busy-indicator--reserving',
};


const HTML = `
  <div class="tn-syos-busy-indicator__content">
    <div class="${Class.MESSAGE}">Loading</div>
  </div>
`;

class SyosBusyIndicator extends SyosUiContainer {
  constructor(syosController) {
    super(syosController, '.tn-syos-busy-indicator');
    this.bindMethods();

    this.toggleSpinner(true);
    this.$el.html(HTML);
    this.$el.show();
    this.$message = this.find(`.${Class.MESSAGE}`);

    this.startGenericListeners();
    this.on(SyosEvents.API_RESERVION_ATTEMPT, this.onReservationAttempt);
    this.on(SyosEvents.API_RESERVATION_FAIL, this.onReservationFail);
    this.on(SyosEvents.API_RESERVATION_SUCCESS, this.onReservationSuccess);
    this.on(SyosEvents.API_SEAT_LIST_REQUEST_CANCELLED, this.onAjaxComplete);
    this.on(SyosEvents.API_REQUEST_ERROR, this.onAjaxError);
  }

  bindMethods() {
    this.onAjaxStart = this.onAjaxStart.bind(this);
    this.onAjaxComplete = this.onAjaxComplete.bind(this);
    this.onAjaxError = this.onAjaxError.bind(this);
    this.onReservationAttempt = this.onReservationAttempt.bind(this);
    this.onReservationFail = this.onReservationFail.bind(this);
    this.onReservationSuccess = this.onReservationSuccess.bind(this);
  }

  startGenericListeners() {
    this.busyCounter = 0;
    this.on(SyosEvents.API_REQUEST_STARTED, this.onAjaxStart);
    this.on(SyosEvents.API_REQUEST_COMPLETED, this.onAjaxComplete);
  }

  stopGenericListeners() {
    this.off(SyosEvents.API_REQUEST_STARTED, this.onAjaxStart);
    this.off(SyosEvents.API_REQUEST_COMPLETED, this.onAjaxComplete);
  }

  showMessage(message) {
    this.$message.html(message);
    this.$el.show();
  }

  onAjaxError() {
    this.toggleSpinner(false);
    this.showMessage(SyosPageComponent.busyIndicatorAjaxError);
  }

  toggleSpinner(showSpinner = true) {
    this.$el.toggleClass(Class.SPINNING, showSpinner);
  }

  onAjaxStart() {
    this.busyCounter += 1;
    if (this.busyCounter === 1) {
      this.showMessage(SyosPageComponent.busyIndicatorLoading);
    }
  }

  onAjaxComplete() {
    this.busyCounter -= 1;
    if (this.busyCounter === 0) {
      this.$el.hide();
    }
  }

  onReservationAttempt() {
    this.stopGenericListeners();
    this.$el.addClass(Class.RESERVING);
    this.showMessage(SyosPageComponent.busyIndicatorReservingSeats);
  }

  onReservationFail() {
    this.startGenericListeners();
    this.$el.removeClass(Class.RESERVING);
    this.$el.hide();
  }

  onReservationSuccess() {
    this.showMessage(SyosPageComponent.busyIndicatorReservationSuccessful);
  }
}

export default SyosBusyIndicator;



// WEBPACK FOOTER //
// ./V7/syos/SyosBusyIndicator.js